import axiosInstance from "../../../util/axiosInstance";
import { requestDocumentAgreements } from '../../../component/documents/DocumentAgreementModal';



export const PlaceOrder = async (paymentAmount) => {
  try {
    const response = await axiosInstance.post('/create-order', {
      amount: paymentAmount,
    });

    const orderData = response.data;
    console.log('Order created on backend:', orderData);


  } catch (error) {
    console.error('Error creating order:', error.response?.data || error.message);
  }
};

export const payment_checkout = async (eventId, request) => {
  request = request.amount ? request : { amount: request };
  try {
    if (!await requestDocumentAgreements({ eventId, amount: request.amount })) {
      throw { cancelled: true, message: 'Document agreements were not completed' };
    }

    const response = await axiosInstance.post(
      `/cart/event/${eventId}/checkout-multi`,
      request
    );
    console.log("payment_checkout", response)
    return response.data; // backend response
  } catch (error) {
    if (error.response?.data?.code === 'DOCUMENT_AGREEMENTS_PENDING') {
      await requestDocumentAgreements({ eventId, amount: request.amount });
      throw { cancelled: true, message: 'Documents updated. Please continue payment when ready.' };
    }
    if (error.cancelled) throw error;
    console.error("Payment Checkout Error:", error);
    throw error.response?.data || error.message;
  }
};

export const payment_verification = async (eventId, verificationData) => {
  try {
    const response = await axiosInstance.post(
      `/cart/event/${eventId}/payments/verify-multi`,
      verificationData
    );

    console.log("Payment verification response:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Payment verification failed:", error.response?.data || error.message);
    throw error;
  }
};
